<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.40039 3.19844C2.40039 2.75661 2.75856 2.39844 3.20039 2.39844H12.8004C13.2422 2.39844 13.6004 2.75661 13.6004 3.19844C13.6004 3.64027 13.2422 3.99844 12.8004 3.99844H3.20039C2.75856 3.99844 2.40039 3.64027 2.40039 3.19844ZM2.40039 6.39844C2.40039 5.95661 2.75856 5.59844 3.20039 5.59844H12.8004C13.2422 5.59844 13.6004 5.95661 13.6004 6.39844C13.6004 6.84027 13.2422 7.19844 12.8004 7.19844H3.20039C2.75856 7.19844 2.40039 6.84027 2.40039 6.39844ZM2.40039 9.59844C2.40039 9.15661 2.75856 8.79844 3.20039 8.79844H12.8004C13.2422 8.79844 13.6004 9.15661 13.6004 9.59844C13.6004 10.0403 13.2422 10.3984 12.8004 10.3984H3.20039C2.75856 10.3984 2.40039 10.0403 2.40039 9.59844ZM2.40039 12.7984C2.40039 12.3566 2.75856 11.9984 3.20039 11.9984H12.8004C13.2422 11.9984 13.6004 12.3566 13.6004 12.7984C13.6004 13.2403 13.2422 13.5984 12.8004 13.5984H3.20039C2.75856 13.5984 2.40039 13.2403 2.40039 12.7984Z"
      fill="white"
    />
  </svg>
</template>
<script>
export default {};
</script>
